export function isPhotoSelectionPanelSupported(page: eXpress.core.IPageZone | undefined | null) {
	if (!page) return false;
	// Don't show when only maps/spotifyCode
	return page.spread.hasZoneForPhotoSourceType("photo");
}
